import agent from 'api/agent';

export const DevTools = {
    GetVersion: () => agent.requests.get('/DevTools/version', {}, true),
};
